import * as yup from "yup";

export const busquedaPorDominioSchema = yup.object({
  valor: yup.string().when("datos_sobre", {
    is: (value) => value === "dominio",
    then: (schema) =>
      schema
        .required("El dominio es requerido")
        .matches(
          /^(?:[A-Z,a-z]{3}\d{3}|[A-Z,a-z]{2}\d{3}[A-Z,a-z]{2}|\d{3}[A-Z, a-z]{3}|[A-Z, a-z]{1}\d{3}[A-Z,a-z]{3})$/,
          { message: "Formato de dominio incorrecto", excludeEmptyString: true }
        ),
    otherwise: (schema) =>
      schema
        .required("Documento o CUIT del titular del vehículo requerido")
        .matches(
          /^(?!0)([0-9]){6,11}$/,
          "El Documento o CUIT debe contener entre 6 y 11 numeros, y no puede comenzar con 0"
        ),
  }),
  correo_electronico: yup
    .string()
    .test("is_valid_email", "El correo electrónico es inválido", (value) => {
      return value === null || value === "" || value === undefined || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/.test(value);
    }),
});

export const guardarCorreoSchema = yup.object({
  correo_electronico: yup
    .string()
    .required('El correo electrónico es requerido')
    .test("is_valid_email", "El correo electrónico es inválido", (value) => {
      return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/.test(value);
    }),
  telefono: yup
    .string()    
    .matches(/^([0-9]){7,20}$/, {
      message:
        "El teléfono es inválido. Solo puede contener números y debe tener entre 7 y 20 caracteres",
      excludeEmptyString: true,
    }),
});
